import { IPart, PartStatus } from "../../models/Part";


export default function PartStatusLabel({
  part,
  width = "w-full",
  compact = false,
}: {
  part: IPart;
  width?: string;
  /** Tighter pill for inline use (e.g. unlisted part type cell). */
  compact?: boolean;
}) {
  const style = compact
    ? "max-w-full shrink-0 rounded-full px-2 py-0.5 text-center text-[10px] font-medium leading-tight sm:text-xs inline-flex h-6 items-center justify-center"
    : "mx-auto flex h-10 items-center justify-center rounded-full px-3 text-center text-xs";
  let colour = "bg-yellow-200 text-yellow-500";

  switch (part.partStatus) {
    case PartStatus.Damaged:
    case PartStatus.Missing:
    case PartStatus["Not Accessible"]:
    case PartStatus.Deleted:
      colour = "bg-red-200 text-red-500";
      break;
    case PartStatus.QC:
      colour = "bg-fuchsia-200 text-fuchsia-500";
      break;
    case PartStatus.Returned:
      colour = "bg-orange-200 text-orange-500";
      break;
    case PartStatus.Dismantled:
      colour = "bg-blue-200 text-blue-500";
      break;
    case PartStatus.Sold:
      colour = "bg-green-200 text-green-500";
      break;
    default:
      break;
  }

  return (
    <div
      className={`${colour} ${style} ${compact ? "w-auto" : width}`}
    >
      <span className="whitespace-nowrap">{PartStatus[part.partStatus]}</span>
    </div>
  )

}